import { inject, Injectable } from "@angular/core";
import { BetPlacementService } from "../../../../../../shared/src/lib/services/bet-placement.service";
import { Bet } from "../../../../../../shared/src/lib/types/bet.type";
import { ApiService } from "../../../../../../shared/src";
import { BehaviorSubject, Subscription } from "rxjs";
import { StorageService } from "../../../../../../shared/src/lib/services/storage.service";

type MyMarketsItem = {
  marketId?: string;
  descriptionPrefix?: string;
  source?: "betslip" | "manual";
  placedDate: string;
};

@Injectable({
  providedIn: "root",
})
export class MyMarketsService {
  subscriptions: Subscription = new Subscription();
  apiService = inject(ApiService);
  placementService = inject(BetPlacementService);
  storage = inject(StorageService);
  myMarkets$ = new BehaviorSubject<Map<string, MyMarketsItem>>(new Map());

  constructor() {
    this.getOpenBets();
  }

  get userId() {
    return this.apiService.getUserToken()?.user?.ID;
  }

  get username() {
    return this.apiService.getUserToken()?.user?.NAME;
  }

  get sessionMarkets(): MyMarketsItem[] {
    // const markets = sessionStorage.getItem(`${this.userId}-my-markets`);
    const markets = this.storage.getItem<MyMarketsItem[]>(`${this.userId}-my-markets`);
    return markets ?? [];
  }

  storeMarket(marketId: string) {
    const newMarket = { marketId, source: "manual", placedDate: new Date() };
    let newMarkets = [...this.sessionMarkets, newMarket];
    // sessionStorage.setItem(`${this.userId}-my-markets`, JSON.stringify(newMarkets));
    this.storage.setItem(`${this.userId}-my-markets`, JSON.stringify(newMarkets));
    this.getOpenBets();
  }

  removeMarket(marketId: string, type: "withUpdate" | "withOutUpdate" = "withUpdate") {
    let newMarkets = [...this.sessionMarkets].filter((market) => market?.marketId !== marketId);
    // sessionStorage.setItem(`${this.userId}-my-markets`, JSON.stringify(newMarkets));
    this.storage.setItem(`${this.userId}-my-markets`, newMarkets);
    if (type === "withUpdate") this.getOpenBets();
  }

  removeOpenBetsMarket(marketId: string) {
    const currentMap = this.myMarkets$.getValue();
    if (currentMap.has(marketId)) {
      const newMap = new Map(currentMap);
      newMap.delete(marketId);
      this.myMarkets$.next(newMap);
    }
    this.removeMarket(marketId, "withOutUpdate");
  }

  consolidateLocalMarkets(latestMarkets: Map<string, MyMarketsItem>) {
    let newMarkets = [...this.sessionMarkets].filter((market) => {
      return market?.marketId && latestMarkets.has(market?.marketId) && latestMarkets.get(market?.marketId)?.source === "manual";
    });
    // sessionStorage.setItem(`${this.userId}-my-markets`, JSON.stringify(newMarkets));
    this.storage.setItem(`${this.userId}-my-markets`, newMarkets);
  }

  getOpenBets() {
    this.placementService.openBetsSubject.subscribe({
      next: (data) => {
        let cuoBets: Map<string, MyMarketsItem> = new Map();
        // markets from session storage (added by user)
        cuoBets = new Map(this.sessionMarkets.map(({ marketId, ...data }) => [marketId ?? "", data]));

        if (data && data.length > 0) {
          // current user order bets
          data?.forEach((bet: Bet) => {
            const { descriptionPrefix, marketId, eventId, providerId, placedDate } = bet || {};
            const marketItem: MyMarketsItem = { source: "betslip", placedDate, descriptionPrefix };
            cuoBets.set(descriptionPrefix ? `${descriptionPrefix}_${eventId}_${providerId}` : marketId, marketItem);
          });

          this.consolidateLocalMarkets(cuoBets);
        }

        // console.log(this.username, this.userId, cuoBets);

        this.myMarkets$.next(cuoBets);
      },
    });
  }
}
